export const deClientPortalValuationOverviewPageCommon = {
    emptyStateTitle: 'Keine Daten zu diesem Objekt gefunden',
    formulas: {
        grossInitialYield: '\\frac{\\text{Vertragsmiete} \\times 100}{\\text{Marktwert}}',
        grossYield: '\\frac{\\text{Marktmiete} \\times 100}{\\text{Marktwert}}',
    },
}
